export enum PermissionActionEnum {
    canAdd = "canAdd",
    canDelete = "canDelete",
    canEdit = "canEdit",
    canReassign = "canReassign",
    canView = "canView",
    canReopen = "canReopen",
    canCompleteMissedVisit = "canCompleteMissedVisit",
    canExport = "canExport",
    canEditBranches = "canEditBranches",
    canAddBranches = "canAddBranches"
}
